<script>
import Layout from '@layouts/main'
import { hmdaMethods, toasterMethods } from '@state/helpers'
import constant from '@constants/constant'
import { hmdaLevels } from '@utils/accesslevels'
import HmdaHeader from '@/src/components/HMDA/HmdaHeader.vue'

export default {
  components: { Layout, HmdaHeader },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
        {
          text: 'HMDA',
          to: { path: '/hmda' },
        },
        { text: 'Rules', active: true },
      ],
      options: [25, 50, 75, 100],
      fields: [
        {
          key: 'index',
          label: 'Sr No',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'ruleName',
          label: 'Rule Name',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'ruleDescription',
          label: 'Rule Description',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'dataAttributesName',
          label: 'HMDA Data Elements',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'ruleText',
          label: 'Rules',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'isRuleActiveB',
          label: 'Status',
          sortable: false,
          class: 'text-left',
        },
      ],
      rulesList: [],
      rows: 0,
      perPage: 25,
      currentPage: 1,
      rowsB: 0,
      perPageB: 25,
      currentPageB: 1,
      filterTable: '',
      isDefault: true,
      headeTitle: 'Rules',
      showSpinner: false,
      commands: [],
      messageType: '',
      showModalAlert: false,
      alertMessage: '',
      customRules: [],
    }
  },

  mounted() {
    hmdaLevels.initializeAccessControls()
    if (!hmdaLevels.canViewRulesList()) {
      return this.$router.push({ name: 'home' })
    }
    this.getTotalRules(this.searchSelected)
  },

  methods: {
    ...hmdaMethods,
    ...toasterMethods,

    getTotalRules(selectedvalue) {
      this.getRules(selectedvalue, 0)
    },

    getRules(selectedvalue, type) {
      this.showSpinner = true
      return this.fetchRulesList({
        PageSize: type ? this.perPageB : this.perPage,
        PageNumber: type ? this.currentPageB : this.currentPage,
        ruleType: type, // 0 => CFPB rules & 1 => custom rules
      })
        .then((response) => {
          switch(type) {
            case 0: this.loadCFPBHMDARules(response)
             break
            case 1: this.loadCustomRules(response)
             break
          }
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.showModalAlert = true
          this.autherror = error
          this.messageType = constant.imageHeaderError
          this.alertMessage = constant.errorMessage
        })
    },
    loadCFPBHMDARules(response) {
      let rl = response ? response.data.rules : [] || []
      this.rows = response.data.totalRulesCount
      rl.forEach((rule) => {
        rule.isRuleActiveB = rule.isRuleActive ? 'Active' : 'Inactive'
      })
      this.rulesList = rl
      this.currentPage = this.currentPage
    },
    loadCustomRules(response) {
      let rl = response ? response.data.rules : [] || []
      this.rowsB = response.data.totalRulesCount
      rl.forEach((rule) => {
        rule.isRuleActiveB = rule.isRuleActive ? 'Active' : 'Inactive'
      })
      this.customRules = rl
      this.currentPageB = this.currentPageB
    },
    // get CFPB HMDA rules
    getCFPBHMDARules(type) {
      if(!this.rulesList.length) {
        this.getRules(this.searchSelected, type)
      }
    },
    // get custom HMDA rules
    getCustomHMDARules(type) {
      if(!this.customRules.length) {
        this.getRules(this.searchSelected, type)
      }
    },

    confirmClicked() {
      this.showModalAlert = false
    },

    paginationEvent(currentPage) {
      if (this.currentPage !== currentPage) {
        this.showSpinner = true
        this.currentPage = currentPage
        this.getRules(this.searchSelected, 0)
      }
    },

    rowPerPageCount(pageValue) {
      this.perPage = parseInt(pageValue)
      this.currentPage = 1
      if (this.rows !== 0) {
        this.showSpinner = true
        this.getRules(this.searchSelected, 0)
      }
    },
    paginationEventB(currentPage) {
      if (this.currentPageB !== currentPage) {
        this.showSpinner = true
        this.currentPageB = currentPage
        this.getRules(this.searchSelected, 1)
      }
    },

    rowPerPageCountB(pageValue) {
      this.perPageB = parseInt(pageValue)
      this.currentPageB = 1
      if (this.rowsB !== 0) {
        this.showSpinner = true
        this.getRules(this.searchSelected, 1)
      }
    },
  },
}
</script>

<template>
  <Layout>
    <HmdaHeader :crumbs="breadcrumbs" />
    <div class="body--wrapper mt-1 bg-white container">
      <BaseSpinner v-if="showSpinner" />

      <BaseModalAlert
        :modal-show="showModalAlert"
        :title-header="messageType"
        :alert-message="alertMessage"
        @confirmClicked="confirmClicked"
      ></BaseModalAlert>

      <div>
        <BaseTitleMenu :heade-title="headeTitle" />

        <div class="border-bottom my-3" />
        <b-card no-body>
        <b-tabs card>
          <b-tab title="CFPB/HMDA Rules" @click="getCFPBHMDARules(0)">
          <BaseDataTable
          ref="table1"
          :options="options"
          :items="rulesList"
          :fields="fields"
          :commands="commands"
          show-envelope
          show-eye
          showdatatablefooter
          :total-rows="rows"
          :per-page="perPage"
          :current-page="currentPage"
          @rowPerPageChange="rowPerPageCount"
          @paginationEvent="paginationEvent"
        >
        </BaseDataTable>
          </b-tab>
          <b-tab title="Custom Rules" class="customRulesTooltip" @click="getCustomHMDARules(1)">
        <BaseDataTable
          ref="table2"
          :options="options"
          :items="customRules"
          :fields="fields"
          :commands="commands"
          show-envelope
          show-eye
          showdatatablefooter
          :total-rows="rowsB"
          :per-page="perPageB"
          :current-page="currentPageB"
          @rowPerPageChange="rowPerPageCountB"
          @paginationEvent="paginationEventB"
        >
        </BaseDataTable>
          </b-tab>
        </b-tabs>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<style>
td:nth-child(3),
td:nth-child(4),
td:nth-child(5) {
  white-space: normal;
  width: 30% !important;
  max-width: 30%;
}
</style>
